import { Loader } from '@pensionbee/honeypot-ui';

type InlineLoaderProps = {
  message?: string;
  screenReaderMessage?: string;
  className?: string;
};

const InlineLoader = ({
  message,
  screenReaderMessage,
  className,
}: InlineLoaderProps) => {
  return (
    <div
      className={`flex justify-center items-center ${className || ''}`}
      role="status"
      aria-live="polite"
      aria-label={message || screenReaderMessage || 'Loading, please wait'}
    >
      <Loader />
      {message && <span className="ml-2 text-gray-700">{message}</span>}
    </div>
  );
};

export default InlineLoader;
